
import firebase from '../fb'
import router from '../router'
import db from '../db'
import axios from 'axios'
import { firestoreAction } from 'vuexfire'

let dispact_withdraw = async(payload) => {
  let {data, vm} = payload
  let baseurl = `${data.base_url}/payment`
  let request_headers = await vm.get_headers(data)
  console.log(request_headers);
  if (location.hostname === "localhost") {
    baseurl = 'http://localhost:4000/payment'
  }
  let url = `${baseurl}/withdraw`
  console.log(data);
  let {amount, asset, id,address} = data
  let post_data = {amount, asset, id, address}
  axios.post(url, {}, request_headers).then(result => {
    console.log(result.data);
    if (result.data == 'processing') {
      swal('success', 'ordre en cours', "success", { button: "ok" });
    } else {
      swal('error', 'erreur veuillez reessayer', "error", { button: "ok" });
    }

  }).catch(error => {
    swal({
      title: "Erreur",
      text: "erreur survenue veuillez reessayer",
      icon: "error",
    })

  })
}


const state = {
  btc_withdraw: [],
  cfa_withdraw: [],
  pm_withdraw: [],
  history_withdraw: [],
};

const getters = {
  cfa_withdraw: state => {
    var user = firebase.auth().currentUser;
    return state.cfa_withdraw.filter(obj => obj.user_id === user.uid)
  },
  btc_withdraw: state => {
    var user = firebase.auth().currentUser;
    return state.btc_withdraw.filter(obj => obj.user_id === user.uid)
  },
  pm_withdraw: state => {
    var user = firebase.auth().currentUser;
    return state.pm_withdraw.filter(obj => obj.user_id === user.uid)
  },

  history_withdraw: state => {
    return state.history_withdraw
  },
};
const mutations = {
  async cfa_withdraw(state, payload) {
    console.log(payload);

    if (payload.montant>0) {
      console.log(payload, 'payload mutation store');
      let {base_url,vm} =payload
      let amount = Number(payload.montant) - Number(payload.fee)
        var user =  firebase.auth().currentUser;
        var result =  db.collection("transactions").doc("cfa").collection("cfa_withdraw").doc()
        var data = {
          id: result.id,
          user_id: user.uid,
          amount: amount,
          didact_amount: Number(payload.montant),
          moyen: payload.moyen,
          numero: payload.numero,
          address: payload.numero,
          name: payload.name,
          token:payload.token,
          asset:'cfa',
          fee:payload.fee,
          base_url,
          status: 'attente',
          created_at: ''
        }

        let post_args ={
          data,
          vm
        }
        dispact_withdraw (post_args)
    

    }else{
      return alert('erreur')
    }
  },

  async btc_withdraw(state, payload) {
    console.log(payload);
    let {base_url,vm} =payload

    let user =  firebase.auth().currentUser;
    
    let result =  db.collection("transactions").doc("btc").collection("btc_withdraw").doc()

    let data = {
      id: result.id,
      user_id: user.uid,
      amount: Number(payload.sendAmount),
      didact_amount: Number(payload.amount),
      pass:payload.pass,
      address: payload.adress,
      btcAddr: payload.adress,
      fee:payload.fee,
      status: 'attente',
      asset:'btc',
      created_at: ''
    }
    let post_args ={
      data,
      vm
    }
    dispact_withdraw (post_args)
  },

  async pm_withdraw(state, payload) {
    let {base_url,vm} =payload
    var user =  firebase.auth().currentUser;
    var result =  db.collection("transactions").doc("pm").collection("pm_withdraw").doc()

    let data = {
      id: result.id,
      user_id: user.uid,
      pass:payload.pass,
      base_url,
      amount: Number(payload.sendAmount),
      didact_amount: Number(payload.amount),
      account: payload.account,
      fee:payload.fee,
      address: payload.account,
      db_amount: Number(payload.sendAmount),
      status: 'attente',
      asset:'pm',
      created_at: ''
    }
    let post_args ={
      data,
      vm
    }
    dispact_withdraw (post_args)

  }

};

const actions = {
  bind_cfa_withdraw: firestoreAction(context => {
    let user = firebase.auth().currentUser;
    return context.bindFirestoreRef('cfa_withdraw', db.collection('transactions').doc('cfa').collection('cfa_withdraw').where("user_id", "==", user.uid).orderBy('created_at', 'desc').limit(10));
  }),
  bind_btc_withdraw: firestoreAction(context => {
    let user = firebase.auth().currentUser;
    return context.bindFirestoreRef('btc_withdraw', db.collection('transactions').doc('btc').collection('btc_withdraw').where("user_id", "==", user.uid).orderBy('created_at', 'desc').limit(10));
  }),
  bind_pm_withdraw: firestoreAction(context => {
    let user = firebase.auth().currentUser;
    return context.bindFirestoreRef('pm_withdraw', db.collection('transactions').doc('pm').collection('pm_withdraw').where("user_id", "==", user.uid).orderBy('created_at', 'desc').limit(10));
  }),

  bind_history_withdraw: firestoreAction(context => {
    let user = firebase.auth().currentUser;
    return context.bindFirestoreRef('history_withdraw', db.collection('history').where("user_id", "==", user.uid).where("type", "==", 'withdraw').orderBy('created_at', 'desc').limit(10));
  }),

  async retraitCfa({ commit }, payload) {
    commit('cfa_withdraw', payload)
  },

  async retraitBtc({ commit }, payload) {
    commit('btc_withdraw', payload)
  },
  async send_cfa({ commit }, payload) {
    commit('send_cfa', payload)
  },

  async retraitPm({ commit }, payload, ) {
    commit('pm_withdraw', payload)
    
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}